/**
 * Created by iamso on 18.05.21
 */

const BarrelAdsWindow = CleverappsWindow.extend({
    onWindowLoaded: function (barrel) {
        this.barrel = barrel;

        this._super({
            name: "barreladswindow",
            title: Messages.get("BarrelAdsWindow.title"),
            content: this.createContent(),
            styles: cleverapps.styles.BarrelAdsWindow.window
        });
    },

    createContent: function () {
        const items = this.barrel.listItems().map(function (reward) {
            return this.createItem(Prizes.Generate([reward]));
        }, this);

        const itemsNode = new cleverapps.Layout(items, {
            direction: cleverapps.UI.HORIZONTAL,
            margin: cleverapps.styles.BarrelAdsWindow.itemsMargin
        });

        const text = cleverapps.UI.generateOnlyText(Messages.get("BarrelAdsWindow.subTitle"), cleverapps.styles.FONTS.BARREL_ADS_TITLE);
        text.setDimensions(itemsNode.width * 0.8, 0);
        text.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
        const content = new cleverapps.Layout([text, itemsNode], {
            direction: cleverapps.UI.VERTICAL,
            margin: cleverapps.styles.BarrelAdsWindow.contentMargin
        });

        items.forEach((item) => {
            item.icon.replaceParentSamePlace(content);
        });

        return content;
    },

    createItem: function (rewards) {
        const styles = cleverapps.styles.BarrelAdsWindow.item;

        const item = new cc.Node();
        item.setAnchorPoint(0.5, 0.5);
        item.setContentSize2(styles);

        const bg = cleverapps.UI.createScale9Sprite(bundles.windows.frames.tile_bg_png, cleverapps.UI.Scale9Rect.TwoPixelXY);
        bg.setContentSize2(item.getContentSize());
        item.addChild(bg, -1);
        bg.setAlignment(item.width / 2, item.height / 2);

        const icon = this.createIcon(rewards[0]);
        item.addChild(icon);
        icon.setAlignment(styles.iconNode);

        const strip = this.createItemStrip(rewards);
        item.addChild(strip);
        strip.setAlignment(styles.strip);

        const title = cleverapps.UI.generateOnlyText(cleverapps.unitsLibrary.getUnitName(rewards[0]), cleverapps.styles.FONTS.BARREL_ADS_ITEM_TITLE || cleverapps.styles.FONTS.BARREL_ADS_TITLE);
        item.addChild(title);
        title.setAlignment(styles.title);
        title.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
        title.setDimensions(styles.title.maxWidth, styles.title.textHeight);

        const layout = new cleverapps.Layout([item, this.createItemButton(rewards)], {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.buttonMargin
        });
        layout.icon = icon;
        return layout;
    },

    createItemStrip: function (rewards) {
        const styles = cleverapps.styles.BarrelAdsWindow.item.strip;

        const strip = cleverapps.UI.createScale9Sprite(bundles.windows.frames.tile_amount_png);
        strip.setContentSize2(styles.width, strip.height);

        const amount = cleverapps.UI.generateImageText(`x${rewards.length}`, cleverapps.styles.FONTS.BARREL_ADS_AMOUNT);
        strip.addChild(amount);
        amount.setAlignment(styles.amount);

        return strip;
    },

    createIcon: function (reward) {
        const styles = cleverapps.styles.BarrelAdsWindow.item.iconNode;

        const unit = new UnitOnCell(reward, {
            shining: styles.shining,
            noWrap: styles.noWrap
        });
        unit.setScale(styles.scale);
        return unit;
    },

    createItemButton: function (rewards) {
        const styles = cleverapps.styles.BarrelAdsWindow.item.button;

        return new cleverapps.UI.Button({
            text: `##${Messages.get("FREE")}`,
            type: cleverapps.styles.UI.Button.Images.button_blue,
            width: styles.width,
            height: styles.height,
            onClicked: this.barrel.showItemAds.bind(this.barrel, rewards, this.createListener(() => {
                this.close();
            }))
        });
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    BARREL_ADS_TITLE: {
        size: 35,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },

    BARREL_ADS_AMOUNT: {
        size: 60,
        color: cleverapps.styles.COLORS.WHITE
    }
});

cleverapps.styles.BarrelAdsWindow = {
    itemsMargin: 65,
    contentMargin: 20,

    item: {
        width: 350,
        height: 540,
        buttonMargin: 20,

        iconNode: {
            x: { align: "center" },
            y: { align: "center", dy: 120 },
            scale: 1.5,
            shining: true
        },

        strip: {
            width: 390,
            x: { align: "center", dx: 8 },
            y: { align: "bottom", dy: 120 },

            amount: {
                x: { align: "center" },
                y: { align: "center", dy: 7 }
            }
        },

        title: {
            maxWidth: 320,
            x: { align: "center" },
            y: { align: "bottom", dy: 50 },
            textHeight: 80
        },

        button: {
            width: 350,
            height: 120
        }
    }
};
